import { render, staticRenderFns } from "./LayoutAreaHeader.vue?vue&type=template&id=994edc5a&"
import script from "./LayoutAreaHeader.vue?vue&type=script&lang=ts&"
export * from "./LayoutAreaHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports